<div class="form-group m-0 w-100">
  <input
    [(ngModel)]="model"
    autocomplete="new-password"
    autocorrect="off"
    autocapitalize="off"
    class="form-field w-100"
    [class.error]="isInvalid()"
    [type]="currentControlType()"
    [placeholder]="placeholder"
    [attr.disabled]="disabled ? '' : null"
    [mask]="mask"
    (blur)="onBlur()"
    [attr.data-testid]="testId">

  <label class="form-label">
    {{ placeholder }}
  </label>

  <div class="d-flex align-items-center form-action">
    <ng-content></ng-content>

    <kh-img
      *ngIf="controlType === inputTypes.Password"
      [path]="currentPasswordIcon"
      class="password-icon cursor kh-grey-accessible"
      (click)="togglePasswordIcon()">
    </kh-img>
  </div>
</div>

<div
  *ngIf="!isInvalid()"
  class="hint mt-kh-1 pl-kh-2">
  <ng-content select="[hint]"></ng-content>
</div>

<div
  *ngIf="isInvalid()"
  class="mt-kh-1 pl-kh-2">

  <div
    *ngFor="let error of getErrorMessages(control.errors)"
    class="kh-small-text kh-text-error"
    data-testid="error-message">
    {{ error }}
  </div>
</div>
